import React from 'react';
import FAQ from './faq';
import { tjenesterFAQData } from '../data/faqData';

const TjenesterFAQ = () => {
  return (
    <FAQ 
      faqData={tjenesterFAQData}
      title="Ofte stillede spørgsmål om vores tjenester"
      subtitle="Find svar på de mest almindelige spørgsmål om vores hjemmeside- og SEO-tjenester. Har du andre spørgsmål? Kontakt os for en personlig snak."
      className="faq-tjenester"
      showCTA={true}
    />
  );
};

export default TjenesterFAQ;
